module.exports = __webpack_public_path__ + "media/newstyle/images/spellcheck-c74c0fd9287bcdbf39e637bbc95af96f.svg";